import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import OrderExportLayoutsMain from "components/menu/master-files/order-export-layouts/main";

const FileManagerRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={OrderExportLayoutsMain}
            />
        </Switch>
    </div>
);

export default connect()(FileManagerRouter);
